import {PropsWithChildren} from "react";
import {useDeviceDetector} from "@/Hooks/useDeviceDetector";
import {router} from "@inertiajs/react";
import {VisitOptions} from "@inertiajs/core/types/types";

export default function (props: PropsWithChildren<Record<string, any>>) {
    const {isMobile} = useDeviceDetector()

    const onClick = (e: React.MouseEvent) => {
        const options: VisitOptions = {
            preserveScroll: props.preserveScroll,
            preserveState: props.preserveState,
        }

        e.preventDefault()
        if (props.href === 'javascript:;') {
            return;
        }

        if (new URL(props.href, window.location.href).host !== window.location.host) {
            window.open(props.href)
            return
        }

        if (isMobile) {
            router.visit(props.href, options)

            return
        }

        if (props.target === '_blank') {
            window.open(props.href)
            return
        }
        router.visit(props.href, options)
    }

    return <a href={props.href} className={props.className} onClick={onClick}>{props.children}</a>
}